import { Link } from "gatsby"
import React from "react"
import classnames, { Argument } from 'classnames'

export const Button: React.FC<{
  variant?: "default" | "white" | "red";
  href?: string
  ahref?: string
  onClick?: () => void
  xtraStyles?: string
  rest?: object
  disabled?: boolean
}> = ({ children, variant = "default", href, ahref, xtraStyles, onClick, rest, disabled }) => {
  const variantStyles: Argument = {
    "": variant === "default",
    "bg-white text-black": variant === "white",
    "bg-red-500 text-black": variant === "red",

    "hover:bg-white hover:text-black": variant === "default" && !disabled,
    "hover:bg-black hover:text-white": variant === "white" && !disabled,
    "hover:bg-white": variant === "red" && !disabled,

    "cursor-pointer": !disabled,
    "cursor-not-allowed": disabled,
  };

  if (ahref) {
    return (
      <a
        className={
          classnames(
            "block uppercase w-full p-4 border text-center border-white h2-universal button focus:outline-none",
            xtraStyles,
            variantStyles
          )
        }
        onClick={onClick}
        href={ahref}
        {...rest}
      >
        {children}
      </a>
    )
  }
  return href ? (
    <Link
      className={
        classnames(
          "block w-full p-4 border text-center border-white h2-universal button focus:outline-none",
          xtraStyles,
          variantStyles
        )
      }
      onClick={onClick}
      to={href}
      {...rest}
    >
      {children}
    </Link>
  ) : (
    <button
      className={
        classnames(
          "w-full p-4 border text-center border-white h2-universal button",
          xtraStyles,
          variantStyles
        )
      }
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  )
}
